import { Type, Validator } from "./Type";
import { Editor } from "../components/Inputs/Script/Editor";
import { FieldRenderProps } from "react-final-form";
import React from "react";
import { CompleterInterface, incidentColors } from "../index";
import { createStyles } from "@material-ui/styles";
import makeStyles from "@material-ui/styles/makeStyles";
import debounce from "lodash/debounce";
import { Theme } from "@material-ui/core";

export interface ScriptOptions {
  mode?: string;
  completer?: CompleterInterface;
  typeSafe?: boolean;
  debounceInput?: number;
}

export const ScriptField = (
  options: ScriptOptions,
  ...validators: Validator[]
) => {
  return new Type({
    Component: ScriptComponent,
    props: {
      mode: options.mode,
      completer: options.completer,
      typeSafe: options.typeSafe,
      debounceInput: options.debounceInput
    },
    validators
  });
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    editorWithError: {
      border: `1px solid ${incidentColors.critical}`,
      borderRadius: theme.shape.borderRadius,
      marginTop: theme.spacing(1),
      width: "100%",
      minWidth: 450,
      backgroundColor: theme.palette.background.paper
    },
    errorMessage: {
      margin: "5px 14px 5px 14px",
      fontSize: 12,
      color: incidentColors.critical
    }
  })
);

const ScriptComponent = ({
  input: { name, onChange, value },
  ...rest
}: FieldRenderProps<any>): any => {
  const props = rest as any;
  const error = props.meta.error;
  const classes = useStyles();

  const change = (value: string) => {
    onChange(value);
  };
  const debounceChange = debounce(change, props.debounceInput || 0);
  return (
    <>
      <Editor
        name={name}
        onChange={debounceChange}
        editorStyle={error ? classes.editorWithError : undefined}
        value={value}
        typeSafe={props.typeSafe}
        readOnly={props.readOnly}
        completer={props.completer}
        mode={props.mode}
      />
      <div className={classes.errorMessage}>{error}</div>
    </>
  );
};
